import { render, staticRenderFns } from "./AddConcurrentLabel.vue?vue&type=template&id=7953b606&scoped=true&"
import script from "./AddConcurrentLabel.vue?vue&type=script&lang=js&"
export * from "./AddConcurrentLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddConcurrentLabel.vue?vue&type=style&index=0&id=7953b606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953b606",
  null
  
)

export default component.exports